import React, {useEffect, useState} from 'react';
import './styles.scss';
import {Column, Row} from '../layout';
import {colors} from '../../util/colors';
import * as fonts from '../../util/fonts';
import {strings} from '../../util/strings';
import {addToWizard} from '../../store/actions';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {get} from '../../api/api';
import {uriGetSinisterDocuments} from '../../api/endpoints';
import ContainerDocumentDownload from '../container-document-download';
import {formatCurrencyExpenses, getCurrencyCode} from '../../util/utility';
import {Icons} from '../../util/icons';
import Icon from '../../components/icon';
import moment from 'moment';

export interface Expense {
  catName: string;
  cover: string;
  medicalAct: string;
  clientValue: any;
  reimbursementValue: any;
  dos?: Date;
  amountClaimed?: any;
  amountCopay?: any;
  amountDeduct?: any;
  amountDisallow?: any;
  amountPaid?: any;
  code?: any;
  indicator?: boolean;
  rejectedReason?: any;
  currency: string;
  partialRefusalReason?: any;
  checkNbr?: any;
  entryDate?: any;
}

interface ExpensesDetailProps {
  process?: any;
  selectedPatient: any;
  occorenceDate: any;
  expenses: Expense[];
  submittedFiles: any[];
  addToWizard(value: any): void;
  labels: typeof strings.pt.createRefund;
  refundLabels: typeof strings.pt.refund;
  estadoId?: string;
  provider?: string;
  type?: string;
  selectedItem?: any;
  selectedBu?: any;
  buStyles: any;
  language: any;
  listOfDocumentsEmitted: any;
  listOfDocumentsAttached: any;
  checkLetterRef?: any;
  defaultLabels?: typeof strings.pt.refund;
}

function ExpensesDetail({
  process,
  defaultLabels,
  occorenceDate,
  expenses,
  estadoId,
  refundLabels,
  type,
  selectedItem,
  selectedBu,
  buStyles,
  listOfDocumentsEmitted,
  listOfDocumentsAttached,
  language,
  checkLetterRef,
}: ExpensesDetailProps) {
  let totalValue = 0;
  let totalPaidByClient = 0;
  let totalDeduct = 0;
  let totalCopay = 0;
  let totalDisallow = 0;
  let totalRefundedValue = 0;
  let tooltipArray: any[] = [];
  expenses.forEach(() => {
    tooltipArray.push(false);
  });

  const [showreimbursementDetails, setShowreimbursementDetails] =
    useState<boolean[]>(tooltipArray);

  function getReasons() {
    let reasons: any[] = [];

    expenses.forEach((item) => {
      item.rejectedReason?.forEach((element: any) => {
        reasons.push(element);
      });
    });

    const uniqueReasons = Array.from(new Set(reasons));
    return uniqueReasons;
  }

  function calculateTotalValue(value: any) {
    const roundedvalue = Math.round((value + Number.EPSILON) * 100) / 100;
    return roundedvalue;
  }

  return (
    <Column className="reimbursement-success-content-container">
      <Column className="reimbursement-success-outer">
        <Column className="reimbursement-success-box-column">
          <Row className="reimbursement-success-row">
            <Column className="reimbursement-success-row-column">
              <Row className="reimbursement-success-row-template">
                <Column className="reimbursement-success-row-left">
                  <Row className="reimbursement-success-row-left-align">
                    <Column style={{...fonts.MM}}>
                      {refundLabels.refundDetail_process}
                    </Column>
                    <Column
                      className="reimbursement-success-result"
                      style={{...fonts.MM}}>
                      {estadoId === '1' || process === undefined
                        ? '-'
                        : process}
                    </Column>
                  </Row>
                  <Row className="reimbursement-success-row-left-align">
                    <Column style={{...fonts.MM}}>
                      {refundLabels.refundDetail_pacient}
                    </Column>
                    <Column
                      className="reimbursement-success-result"
                      style={{...fonts.MM}}>
                      {/* {selectedPatient} */}
                      {/* name on the card */}
                      {selectedBu.memberName}
                    </Column>
                  </Row>
                </Column>
                <Column className="reimbursement-success-row-right">
                  <Row className="reimbursement-success-row-left-align">
                    <Column style={{...fonts.MM}}>
                      {refundLabels.refundDetail_date}
                    </Column>
                    <Column
                      className="reimbursement-success-result"
                      style={{...fonts.MM}}>
                      {moment(occorenceDate).format(
                        defaultLabels?.refund_claim_date_format
                          ? defaultLabels?.refund_claim_date_format
                          : 'DD/MM/YYY',
                      )}
                    </Column>
                  </Row>
                  {estadoId !== '1' && estadoId !== '' && (
                    <Row className="reimbursement-success-row-left-align">
                      <Column style={{...fonts.MM}}>
                        {refundLabels.refundDetail_provider}
                      </Column>
                      <Column
                        className="reimbursement-success-result"
                        style={{...fonts.MM}}>
                        {/* provider */}
                        {selectedItem.clinicName}
                      </Column>
                    </Row>
                  )}
                </Column>
              </Row>
            </Column>
          </Row>
        </Column>
      </Column>
      {expenses.map((expense, index) => {
        const deduct = expense.amountDeduct;
        const copay = expense.amountCopay;
        const disallowedValue = expense.amountDisallow;
        const paidByClient = deduct + copay + disallowedValue;
        const refundedValue = expense.amountPaid;
        const value = expense.amountClaimed;
        const currency = expenses[0].currency;
        const partialRefusalReason = expense.partialRefusalReason;
        totalDeduct += deduct;
        totalCopay += copay;
        totalDisallow += disallowedValue;
        totalPaidByClient += paidByClient;
        totalRefundedValue += refundedValue;
        totalValue += value;

        const partialRefusalReasonDetailsLabel =
          partialRefusalReason && partialRefusalReason.length > 0
            ? partialRefusalReason[0].partialRefusalReasonDetails.map(
                (reason: any) => {
                  if (reason.languageAlias === language) {
                    return reason.description;
                  }
                },
              )
            : '';

        return (
          <div>
            <Column className="reimbursement-success-outer">
              <Column className="reimbursement-success-box-column">
                <Row className="reimbursement-success-row">
                  <Column className="reimbursement-success-row-column">
                    <Row className="reimbursement-success-row-template">
                      <Column className="reimbursement-success-row-left">
                        <Row className="reimbursement-success-row-left-align">
                          <Column style={{...fonts.MM}}>
                            {refundLabels.refundDetail_coverage}
                          </Column>
                          <Column
                            className="reimbursement-success-result"
                            style={{...fonts.MM}}>
                            {expense.catName}
                          </Column>
                        </Row>
                        <Row className="reimbursement-success-row-left-align">
                          <Column style={{...fonts.MM, textAlign: 'start'}}>
                            {refundLabels.refundDetail_medicalAct}
                          </Column>
                          <Column
                            className="reimbursement-success-result"
                            style={{...fonts.MM}}>
                            {expense.medicalAct}
                          </Column>
                        </Row>
                      </Column>
                      <Column className="reimbursement-success-row-right">
                        <Row className="reimbursement-success-row-left-align">
                          <Column
                            className="reimbursement-success-right-label"
                            style={{...fonts.MM}}>
                            {refundLabels.refundDetail_value}
                          </Column>
                          <Column
                            className="reimbursement-success-result"
                            style={{...fonts.MM}}>
                            {formatCurrencyExpenses(value, currency, language)}
                          </Column>
                        </Row>
                      </Column>
                    </Row>
                  </Column>
                </Row>
              </Column>
            </Column>
            <Column className="reimbursement-success-extra-info-outer">
              <Column className="reimbursement-success-extra-info-column">
                <Row className="reimbursement-success-row">
                  <Column className="reimbursement-success-row-column">
                    <Row className="reimbursement-success-row-template">
                      <Column className="reimbursement-success-row-left"></Column>
                      <Column className="reimbursement-success-row-right">
                        <Row className="reimbursement-success-row-left-align">
                          <Column
                            className="reimbursement-success-right-label"
                            style={{
                              ...fonts.MM,
                              ...fonts.Bold,
                              opacity: estadoId === '1' ? 0.4 : 1,
                            }}>
                            {refundLabels.refundDetail_client}
                          </Column>
                          <Column
                            className="reimbursement-success-result"
                            style={{
                              ...fonts.MM,
                              ...fonts.Bold,
                              opacity: estadoId === '1' ? 0.4 : 1,
                            }}>
                            {estadoId === '1'
                              ? '-'
                              : formatCurrencyExpenses(
                                  paidByClient,
                                  currency,
                                  language,
                                )}
                          </Column>
                          {estadoId !== '1' &&
                            estadoId !== '4' &&
                            !!(deduct || copay || disallowedValue) && (
                              <Icon
                                name={
                                  showreimbursementDetails[index]
                                    ? Icons.CHEVRON_WITH_CIRCLE_UP
                                    : Icons.CHEVRON_WITH_CIRCLE_DOWN
                                }
                                onClick={() => {
                                  let aux = [...showreimbursementDetails];
                                  aux[index] = !aux[index];
                                  setShowreimbursementDetails(aux);
                                }}
                                width="20"
                                height="20"
                                color={buStyles.primaryColor}
                                className="chevron-down-icon"
                                strokeWidth="1.5px"
                                changeViewbox={false}
                                viewBox={'0, 0, 20, 20'}
                                style={{marginRight: '-27.2px'}}
                              />
                            )}
                        </Row>

                        {estadoId !== '1' &&
                          estadoId !== '4' &&
                          showreimbursementDetails[index] &&
                          !!(deduct || copay || disallowedValue) && (
                            <React.Fragment>
                              {!!deduct && (
                                <>
                                  <Row className="reimbursement-success-row-left-align reimbursement-detail-label reimbursement-detail-first-label">
                                    <Column
                                      className="reimbursement-success-right-label reimbursement-success-right-label-detail"
                                      style={{
                                        ...fonts.MM,
                                        opacity: estadoId === '1' ? 0.4 : 1,
                                      }}>
                                      {refundLabels.refundDetail_deduct}
                                    </Column>
                                    <Column
                                      className="reimbursement-success-result"
                                      style={{
                                        ...fonts.MM,
                                        opacity: estadoId === '1' ? 0.4 : 1,
                                      }}>
                                      {formatCurrencyExpenses(
                                        deduct,
                                        currency,
                                        language,
                                      )}
                                    </Column>
                                  </Row>
                                  <Row className="reimbursement-success-row-left-align reimbursement-detail-label">
                                    <Column
                                      className="reimbursement-success-right-label reimbursement-success-right-label-detail"
                                      style={{...fonts.M, color: '#9C9C9C'}}>
                                      {refundLabels.refundDetail_deductContext}
                                    </Column>
                                  </Row>
                                </>
                              )}
                              {!!copay && (
                                <>
                                  <Row className="reimbursement-success-row-left-align reimbursement-detail-label">
                                    <Column
                                      className="reimbursement-success-right-label reimbursement-success-right-label-detail"
                                      style={{
                                        ...fonts.MM,
                                        opacity: estadoId === '1' ? 0.4 : 1,
                                      }}>
                                      {refundLabels.refundDetail_copay}
                                    </Column>
                                    <Column
                                      className="reimbursement-success-result"
                                      style={{
                                        ...fonts.MM,
                                        opacity: estadoId === '1' ? 0.4 : 1,
                                      }}>
                                      {formatCurrencyExpenses(
                                        copay,
                                        currency,
                                        language,
                                      )}
                                    </Column>
                                  </Row>{' '}
                                </>
                              )}
                              {!!disallowedValue && (
                                <>
                                  <Row className="reimbursement-success-row-left-align reimbursement-detail-label">
                                    <Column
                                      className="reimbursement-success-right-label reimbursement-success-right-label-detail"
                                      style={{
                                        ...fonts.MM,
                                        opacity: estadoId === '1' ? 0.4 : 1,
                                      }}>
                                      {refundLabels.refundDetail_disallow}
                                    </Column>
                                    <Column
                                      className="reimbursement-success-result"
                                      style={{
                                        ...fonts.MM,
                                        opacity: estadoId === '1' ? 0.4 : 1,
                                      }}>
                                      {formatCurrencyExpenses(
                                        disallowedValue,
                                        currency,
                                        language,
                                      )}
                                    </Column>
                                  </Row>
                                  {partialRefusalReasonDetailsLabel && (
                                    <>
                                      <Row className="reimbursement-success-row-left-align reimbursement-detail-label">
                                        <Column
                                          className="reimbursement-success-right-label reimbursement-success-right-label-detail"
                                          style={{
                                            ...fonts.M,
                                            color: '#9C9C9C',
                                          }}>
                                          {partialRefusalReasonDetailsLabel}
                                        </Column>
                                      </Row>{' '}
                                    </>
                                  )}
                                </>
                              )}
                            </React.Fragment>
                          )}
                        <Row className="reimbursement-success-row-left-align reimbursement-detail-last-label">
                          {type && (
                            <Column
                              className="reimbursement-success-right-label"
                              style={{
                                ...fonts.MM,
                                ...fonts.Bold,
                                opacity: estadoId === '1' ? 0.4 : 1,
                              }}>
                              {type !== 'FORA DA REDE'
                                ? refundLabels.refundDetail_insurance
                                : refundLabels.refundDetail_refundValue}
                            </Column>
                          )}
                          {!type && (
                            <Column
                              className="reimbursement-success-right-label reimbursement-success-row-detail-label"
                              style={{
                                ...fonts.MM,
                                ...fonts.Bold,
                                opacity: estadoId === '1' ? 0.4 : 1,
                              }}>
                              {refundLabels.refundDetail_refundValue}
                            </Column>
                          )}
                          <Column
                            className="reimbursement-success-result"
                            style={{
                              ...fonts.MM,
                              ...fonts.Bold,
                              opacity: estadoId === '1' ? 0.4 : 1,
                            }}>
                            {estadoId === '1'
                              ? '-'
                              : formatCurrencyExpenses(
                                  refundedValue,
                                  currency,
                                  language,
                                )}
                          </Column>
                        </Row>
                      </Column>
                    </Row>
                  </Column>
                </Row>
              </Column>
            </Column>
          </div>
        );
      })}
      <Column className="reimbursement-success-outer">
        <Column className="reimbursement-success-box-column">
          <Row className="reimbursement-success-row">
            <Column className="reimbursement-success-row-column">
              <Row className="reimbursement-success-row-template">
                <Column className="reimbursement-success-row-left">
                  <Row
                    className="reimbursement-success-row-left-align reimbursement-success-total-value"
                    style={{
                      ...fonts.L,
                      ...fonts.Bold,
                      color: colors.black,
                      marginTop: '0.5rem',
                    }}>
                    {refundLabels.refundDetail_totalValue}
                  </Row>
                </Column>
                <Column className="reimbursement-success-row-right">
                  <Row className="reimbursement-success-row-left-align-total-value">
                    <Column
                      className="reimbursement-success-right-label reimbursement-success-total-value-responsive"
                      style={{
                        ...fonts.MM,
                        ...fonts.Bold,
                        color: colors.black,
                      }}>
                      {refundLabels.refundDetail_totalValue}
                    </Column>
                    <Column
                      className="reimbursement-success-result reimbursement-success-result-total-value"
                      style={{...fonts.L, color: colors.black}}>
                      {formatCurrencyExpenses(
                        totalValue,
                        expenses[0]?.currency,
                        language,
                      )}
                    </Column>
                  </Row>
                  <Row className="reimbursement-success-row-left-align reimbursement-success-row-detail-label">
                    <Column
                      className="reimbursement-success-right-label"
                      style={{
                        ...fonts.MM,
                        ...fonts.Bold,
                        opacity: estadoId === '1' ? 0.4 : 1,
                      }}>
                      {refundLabels.refundDetail_client}
                    </Column>
                    <Column
                      className="reimbursement-success-result"
                      style={{
                        ...fonts.MM,
                        ...fonts.Bold,
                        opacity: estadoId === '1' ? 0.4 : 1,
                      }}>
                      {estadoId === '1'
                        ? '-'
                        : formatCurrencyExpenses(
                            totalPaidByClient,
                            expenses[0]?.currency,
                            language,
                          )}
                    </Column>
                  </Row>
                  {estadoId !== '1' && estadoId !== '4' && (
                    <React.Fragment>
                      {' '}
                      <Row className="reimbursement-success-row-left-align reimbursement-detail-label reimbursement-detail-first-label">
                        <Column
                          className="reimbursement-success-right-label reimbursement-success-right-label-detail"
                          style={{
                            ...fonts.MM,
                            opacity: estadoId === '1' ? 0.4 : 1,
                          }}>
                          {refundLabels.refundDetail_deduct}
                        </Column>
                        <Column
                          className="reimbursement-success-result"
                          style={{
                            ...fonts.MM,
                            opacity: estadoId === '1' ? 0.4 : 1,
                          }}>
                          {formatCurrencyExpenses(
                            totalDeduct,
                            expenses[0]?.currency,
                            language,
                          )}
                        </Column>
                      </Row>
                      <Row className="reimbursement-success-row-left-align reimbursement-detail-label">
                        <Column
                          className="reimbursement-success-right-label reimbursement-success-right-label-detail"
                          style={{
                            ...fonts.MM,
                            opacity: estadoId === '1' ? 0.4 : 1,
                          }}>
                          {refundLabels.refundDetail_copay}
                        </Column>
                        <Column
                          className="reimbursement-success-result"
                          style={{
                            ...fonts.MM,
                            opacity: estadoId === '1' ? 0.4 : 1,
                          }}>
                          {formatCurrencyExpenses(
                            totalCopay,
                            expenses[0]?.currency,
                            language,
                          )}
                        </Column>
                      </Row>{' '}
                      <Row className="reimbursement-success-row-left-align reimbursement-detail-label">
                        <Column
                          className="reimbursement-success-right-label reimbursement-success-right-label-detail"
                          style={{
                            ...fonts.MM,
                            opacity: estadoId === '1' ? 0.4 : 1,
                          }}>
                          {refundLabels.refundDetail_disallow}
                        </Column>
                        <Column
                          className="reimbursement-success-result"
                          style={{
                            ...fonts.MM,
                            opacity: estadoId === '1' ? 0.4 : 1,
                          }}>
                          {formatCurrencyExpenses(
                            totalDisallow,
                            expenses[0]?.currency,
                            language,
                          )}
                        </Column>
                      </Row>{' '}
                    </React.Fragment>
                  )}
                  <Row className="reimbursement-success-row-left-align">
                    {type && (
                      <Column
                        className="reimbursement-success-right-label"
                        style={{
                          ...fonts.MM,
                          ...fonts.Bold,
                          opacity: estadoId === '1' ? 0.4 : 1,
                        }}>
                        {type !== 'FORA DA REDE'
                          ? refundLabels.refundDetail_insurance
                          : refundLabels.refundDetail_refundValue}
                      </Column>
                    )}
                    {!type && (
                      <Column
                        className="reimbursement-success-right-label"
                        style={{
                          ...fonts.MM,
                          ...fonts.Bold,
                          opacity: estadoId === '1' ? 0.4 : 1,
                        }}>
                        {refundLabels.refundDetail_refundValue}
                      </Column>
                    )}
                    <Column
                      className="reimbursement-success-result"
                      style={{
                        ...fonts.MM,
                        ...fonts.Bold,
                        opacity: estadoId === '1' ? 0.4 : 1,
                      }}>
                      {formatCurrencyExpenses(
                        totalRefundedValue,
                        expenses[0]?.currency,
                        language,
                      )}
                    </Column>
                  </Row>
                </Column>
              </Row>
            </Column>
          </Row>
        </Column>
      </Column>
      <Row className="reimbursement-success-documents-row">
        <Column className="reimbursement-success-documents-column">
          {listOfDocumentsAttached !== undefined && (
            <ContainerDocumentDownload
              documentIds={listOfDocumentsAttached}
              title={
                refundLabels.refundDetail_anexDoc
              }></ContainerDocumentDownload>
          )}
        </Column>
        <Column
          ref={checkLetterRef}
          className="reimbursement-success-documents-column">
          {listOfDocumentsEmitted !== undefined && (
            <div ref={checkLetterRef}>
              <ContainerDocumentDownload
                documentIds={listOfDocumentsEmitted}
                title={
                  refundLabels.refundDetail_emitDoc
                }></ContainerDocumentDownload>
            </div>
          )}
        </Column>
      </Row>
    </Column>
  );
}

const mapStateToProps = ({
  stringsDefault,
  strings,
  selectedBu,
  globalStyles,
  language,
}: any) => ({
  labels: strings.value.pt.createRefund,
  refundLabels: strings.value.pt.refund,
  selectedBu: selectedBu.value,
  buStyles: globalStyles.value,
  language: language.value,
  defaultLabels: stringsDefault.value.pt.refund,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(ExpensesDetail),
);
